import { FC, useContext, useState } from "react";
import NotificationDispatch, { showErrorNotification } from "../../context/notificationContext";
import { useI18n } from "../../hooks/useTranslations";
import { useClientsApi } from "../../http/clients/api";
import { SearchClient } from "../../http/clients/types";
import ModalDialog from "../ui/ModalDialog";

type DeleteAdminClientDialogProps = {
  client: SearchClient;
  onClose: () => void;
};

const DeleteAdminClientDialog: FC<DeleteAdminClientDialogProps> = ({ client, onClose }) => {
  const i18n = useI18n();
  const dispatch = useContext(NotificationDispatch);
  const clinetsApi = useClientsApi();
  const [isSubmitting, setIsSubmitting] = useState(false);

  return (
    <ModalDialog
      onClose={onClose}
      title={i18n.t.clients.delete}
      isSubmitting={isSubmitting}
      actions={[
        {
          title: i18n.t.common.cancel,
          onClick: onClose,
          type: "secondary",
        },
        {
          title: i18n.t.common.yes,
          onClick: () => {
            setIsSubmitting(true);
            clinetsApi
              .deleteAdminClient(client.id)
              .then(onClose)
              .catch((err) => dispatch(showErrorNotification(i18n, err)))
              .finally(() => setIsSubmitting(false));
          },
        },
      ]}
    >
      {i18n.t.clients.questions.delete}
    </ModalDialog>
  );
};

export default DeleteAdminClientDialog;
